// extracted by mini-css-extract-plugin
module.exports = {"heroHeader":"style-module__heroHeader___7S7nB","registeredMark":"style-module__registeredMark___qt4-y"};